export default {
    /**
     * @see https://stackoverflow.com/questions/26084733/convert-multidimensional-object-to-query-string
     */
    toQueryString(obj, prefix = null) {
        let str = [], k, v;
        for(let p in obj) {
            if (!obj.hasOwnProperty(p)) {continue;} // skip things from the prototype
            if (~p.indexOf('[')) {
                k = prefix ? prefix + "[" + p.substring(0, p.indexOf('[')) + "]" + p.substring(p.indexOf('[')) : p;
                // only put whatever is before the bracket into new brackets; append the rest
            } else {
                k = prefix ? prefix + "[" + p + "]" : p;
            }
            v = obj[p];
            str.push(typeof v == "object"
                ? this.toQueryString(v, k)
                : encodeURIComponent(k) + "=" + encodeURIComponent(v));
        }
        return str.join("&");
    },

    getViewport () {
        // https://stackoverflow.com/a/8876069
        const width = Math.max(
            document.documentElement.clientWidth,
            window.innerWidth || 0
        )
        if (width <= 576) return 'xs'
        if (width <= 768) return 'sm'
        if (width <= 992) return 'md'
        if (width <= 1200) return 'lg'
        return 'xl'
    },
}
